<!-- ==================== APP HEADER ==================== -->
<div class="app-header">
    <!-- ==================== LOGO + SLOGAN ==================== -->
    <div class="flex align-items-center gap-3">
        <a routerLink="/" class="logo-container">
            <img src="/loggo1.png" alt="YLLW Logo" class="header-logo" />
        </a>
        <small class="text-muted logo-slogan">Transforming spaces driving growth</small>
    </div>

    <!-- ==================== SHOPPING LISTS + BASKET ==================== -->
    <nav class="flex align-items-center gap-1">
        <a
            class="icon-link"
            routerLink="/shopping-lists"
            routerLinkActive="active"
            #listsLink="routerLinkActive"
            [pTooltip]="'LAYOUT.HEADER.SHOPPINGLISTS' | translate"
            tooltipPosition="bottom"
            [attr.aria-label]="'LAYOUT.HEADER.SHOPPINGLISTS' | translate"
        >
            <i class="pi" [class.pi-heart-fill]="listsLink.isActive" [class.pi-heart]="!listsLink.isActive" aria-hidden="true"></i>
            @if (shoppingListCount() > 0) {
            <span class="icon-badge">{{ shoppingListCount() }}</span>
            }
        </a>
        <a
            class="icon-link"
            routerLink="/product-basket"
            routerLinkActive="active"
            [pTooltip]="'LAYOUT.HEADER.BASKET' | translate"
            tooltipPosition="bottom"
            [attr.aria-label]="'LAYOUT.HEADER.BASKET' | translate"
        >
            <i class="pi pi-shopping-cart" aria-hidden="true"></i>
            @if (basketItemCount() > 0) {
            <span class="icon-badge">{{ basketItemCount() }}</span>
            }
        </a>
    </nav>
</div>
